import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/main.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import { hasPermission } from '@/utils/permission'

const app = createApp(App)

// Global permission helper
app.config.globalProperties.$can = (permission) => {
  const role = store.getters['users/role']

  return hasPermission(role, permission)
}

app
  .use(router)
  .use(store)
  .component('v-select', vSelect)
  .mount('#app')



  